import {
  Discussion,
  DiscussionSubjectTypes,
  Identifiable,
  Project,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function createDiscussion(httpClient: HttpClient) {
  return (name: string, project: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<Identifiable<Discussion>>({
        endpoint: "/discussions",
        method: HttpMethods.POST,
        data: {
          entityUuid: project.uuid,
          entityType: DiscussionSubjectTypes.PROJECT,
          project: `/projects/${project.uuid}`,
          attributes: { name },
        },
      })
      .then(
        (discussion) =>
          ({
            ...discussion,
            entityUuid: project.uuid,
            entityType: DiscussionSubjectTypes.PROJECT,
            subject: project,
            attributes: { name },
            comments: [],
          }) as Identifiable<Discussion>,
      );
}

export { createDiscussion };
